import { connect } from 'react-redux'
import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { injectIntl, FormattedMessage } from 'react-intl'

import * as selectors from '../events.selectors'

import * as actions from '../events.actions'
import * as miningActions from '../../Mining/mining.actions'

/**
 *  Pop up showed when you have finished the game
 */
class EventsViewer extends React.Component {
  /**
   *  Component constructor.
   */
  constructor(props) {
    super(props)
    this.state = {
      optionSelected: false,
    }
  }

  selectEventOption(option, index) {
    const { chooseEventOption, executedEvent } = this.props

    this.setState({ optionSelected: true })
    chooseEventOption({
      effect: option.action ? option : false,
      id: executedEvent.id,
      type: executedEvent.type,
      optionSelected: `option_${index + 1}`,
    })
  }

  renderCoins(coins) {
    return [
      <FormattedMessage
        key="message"
        id={`events.${coins < 0 ? 'lose' : 'win'}`}
        values={{ value: Math.abs(coins) }}
      />,
      <span key="coin" className="orange">
        <span className="icon-coin"> </span>
      </span>,
    ]
  }

  renderButtons(options, eventId) {
    const { changeMiningScreen } = this.props
    const { optionSelected } = this.state

    if (!options) {
      return (
        <div
          onClick={() => changeMiningScreen('mining_default')}
          className="btn--shape shape--orange"
        >
          <div className="btn--shape__canvas">
            <span>
              <FormattedMessage id={`events.accept`} />
            </span>
          </div>
        </div>
      )
    }

    return options.map((option, index) => {
      return (
        <div
          key={index}
          onClick={() => (!optionSelected ? this.selectEventOption(option, index) : null)}
          className="btn--shape shape--orange"
        >
          <div className="btn--shape__canvas">
            <span>
              <FormattedMessage id={`events.${eventId}.option_${index + 1}.button`} />
            </span>
          </div>
        </div>
      )
    })
  }

  renderEffect(effect) {
    const { intl } = this.props
    if (!effect) {
      return null
    }

    return (
      <div className="mina--event__subtitle orange">
        {effect.action != 'coins' ? (
          <FormattedMessage
            id={`events.${effect.action}`}
            values={{
              value: intl.formatMessage({
                id: `buildings.${effect.value.name ? effect.value.name : effect.value}`,
              }),
            }}
          />
        ) : (
          this.renderCoins(effect.value)
        )}
      </div>
    )
  }
  renderDecisionText() {
    const { executedEvent } = this.props
    const { optionSelected, id } = executedEvent

    return optionSelected ? (
      <FormattedMessage id={`events.${id}.${optionSelected}.selected`} />
    ) : (
      <FormattedMessage id={`events.${id}.text`} />
    )
  }

  render() {
    const { executedEvent } = this.props
    const { effect, options, id, type } = executedEvent

    return (
      <div className="mina fadeInLeft-animation">
        <div className="mina--layer vertical--center">
          <div className="mina--event">
            <div className="mina--event__title orange">
              <FormattedMessage id={`events.title`} />
              {this.renderEffect(effect)}
            </div>
            <div className="mina--event__text">
              {type == 'decision' ? (
                this.renderDecisionText()
              ) : (
                <FormattedMessage id={`events.${id}`} />
              )}
            </div>
          </div>
          <div className="mina--buttons">{this.renderButtons(options, id)}</div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    executedEvent: selectors.getExecutedEvent(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    changeMiningScreen: bindActionCreators(miningActions.changeMiningScreen, dispatch),
    chooseEventOption: bindActionCreators(actions.chooseEventOption, dispatch),
  }
}

EventsViewer.propTypes = {
  changeMiningScreen: PropTypes.func,
  chooseEventOption: PropTypes.func,
  executedEvent: PropTypes.object,
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(EventsViewer))
